module.exports = __webpack_public_path__ + "static/rimac-thumbnail-09a1cc852097858629ebfab3f6527c23.jpg";